import { render, staticRenderFns } from "./RegisterFeatureList.vue?vue&type=template&id=4311d1df&"
import script from "./RegisterFeatureList.vue?vue&type=script&lang=js&"
export * from "./RegisterFeatureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports